import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { compose } from 'recompose'

import { Modal } from 'containers/misc'
import { CoordinatorAdd, CoordinatorSettings } from 'containers/forms/coordinators'
import { FormData, Module } from 'components/misc'
import { Title } from 'components/layout'
import { apiContacts } from 'helpers/decorators/api'

import { contactsDropdownSelector } from 'redux/selectors/contacts'

const enhance = compose(
  apiContacts({
      onlyActive: true
    }
  ),
  connect(state => ({
    dropdownOrganizationContacts: contactsDropdownSelector(state)
  }))
)

class Coordinators extends Component {
  static propTypes = {
    data: PropTypes.array,
    modal: PropTypes.func.isRequired,
    fetchOrganizationContacts: PropTypes.func.isRequired,
    onContactChange: PropTypes.func.isRequired,
    onRemoveCoordinator: PropTypes.func.isRequired,
    onMakeLeadCoordinator: PropTypes.func.isRequired,
    dropdownOrganizationContacts: PropTypes.array.isRequired,
    organizationId: PropTypes.number
  }

  static defaultProps = {
    data: [],
    dropdownOrganizationContacts: []
  }

  state = {
    contactToEditId: null
  }

  key = uuid.v1()

  handleModalDisplay = () => {
    this.props.modal(`modal-contact-change-${this.key}`)
    this.props.fetchOrganizationContacts()
  }

  handleEditCoordinator = contactToEditId => {
    this.setState({
      contactToEditId
    })
    this.props.modal(`modal-contact-edit-${contactToEditId}`)
  }

  handleCloseEditModal = () => {
    this.setState(
      {
        contactToEditId: null
      },
      () => this.props.modal(null)
    )
  }

  renderRow = (item, { isLeadCoordinator = false } = {}) => (
    <div>
      <div className="row">
        <div className="col-xs-4">
          <FormData label="First Name" intlKey="label.first_name">
            {get(item, 'firstName') || get(item, 'person.firstName') || '---'}
          </FormData>
        </div>
        <div className="col-xs-4">
          <FormData label="Middle Name" intlKey="label.middle_name">
            {get(item, 'middleName') || get(item, 'person.middleName') || '---'}
          </FormData>
        </div>
        <div className="col-xs-3">
          <FormData label="Last Name" intlKey="label.last_name">
            {get(item, 'lastName') || get(item, 'person.lastName') || '---'}
          </FormData>
        </div>
        {item &&
          !isLeadCoordinator &&
          <div className="col-xs-1 text--center">
            <span
              className="ico ico--edit btn-edit"
              style={{ position: 'relative', top: 2 }}
              onClick={() => this.handleEditCoordinator(item.id)}
            />
          </div>}
      </div>
      <div className="row">
        <div className="col-xs-4">
          <FormData label="Email" intlKey="label.email">
            {get(item, 'email') || get(item, 'person.email') || '---'}
          </FormData>
        </div>
        <div className="col-xs-4">
          <FormData label="Phone" intlKey="label.phone">
            {get(item, 'phone') || get(item, 'person.phone') || '---'}
          </FormData>
        </div>
      </div>
    </div>
  )

  render () {
    const { data, dropdownOrganizationContacts, organizationId } = this.props

    const { contactToEditId } = this.state

    let leadCoordinator = this.renderRow()

    let otherCoordinators = []

    if (data.length > 0) {
      leadCoordinator = data
        .filter(item => item.isLeadCoordinator)
        .map((item, index) => (
          <div key={`${item.id}-${index}`}>
            {this.renderRow(item, {
              isLeadCoordinator: item.isLeadCoordinator
            })}
          </div>
        ))

      otherCoordinators = data
        .filter(item => !item.isLeadCoordinator)
        .map((item, index) => (
          <div key={`${item.id}-${index}`}>
            {index !== 0 && <hr className="hr base-margin--bottom" />}
            {this.renderRow(item)}
          </div>
        ))
    }

    const hasLeadCoordinator = leadCoordinator.length > 0

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': this.handleModalDisplay,
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': 'button.add_coordinator',
        'action': 'Add Coordinator'
      }
    ]

    return (
      <div>
        <Module
          title={hasLeadCoordinator ? 'Lead coordinators' : 'Coordinators'}
          intlKey={
            hasLeadCoordinator
              ? 'moduleTitle.lead_coordinator'
              : 'moduleTitle.coordinators'
          }
          primary
          grid
          buttonDefinition={buttonDefinition}
        >
          {leadCoordinator}
          {hasLeadCoordinator &&
            otherCoordinators.length > 0 &&
            <Title h2 intlKey="moduleTitle.other_coordinators">
              Other coordinators
            </Title>}
          {otherCoordinators}
        </Module>
        <Modal
          id={`modal-contact-change-${this.key}`}
          customActions
          enableOverflow
        >
          <CoordinatorAdd
            organizationId={organizationId}
            data={data}
            dropdownOrganizationContacts={dropdownOrganizationContacts}
            onContactChange={this.props.onContactChange}
            onClose={this.handleCloseEditModal}
          />
        </Modal>
        <Modal id={`modal-contact-edit-${contactToEditId}`} customActions>
          <CoordinatorSettings
            contactId={contactToEditId}
            organizationId={organizationId}
            onRemoveCoordinator={this.props.onRemoveCoordinator}
            onMakeLeadCoordinator={this.props.onMakeLeadCoordinator}
            onClose={this.handleCloseEditModal}
          />
        </Modal>
      </div>
    )
  }
}

export default enhance(Coordinators)
